import React from 'react';
import { ModalMainStyled } from './modal.styled';
import {
    EuiButton, EuiCodeBlock, EuiCopy,
    EuiModal,
    EuiModalBody,
    EuiModalHeader,
    EuiModalHeaderTitle, EuiSpacer
} from "@elastic/eui";
import { RunCodeStyled } from "../../../style/components/common.styled";
import { getAgentInstallCommand } from "../../../constants/agent.constants";

const ModalUpdateAgent = ({ data, close }) => {
    const { server } = data;
    const installCommand = getAgentInstallCommand(server._id);

    return (
        <ModalMainStyled>
            <EuiModal onClose={ close }>
                <EuiModalHeader>
                    <EuiModalHeaderTitle><h1>Update Agent</h1></EuiModalHeaderTitle>
                </EuiModalHeader>

                <EuiModalBody>
                    <div className="install">
                        <RunCodeStyled>
                            Run following code as root in your server to install the
                            agent
                            <EuiSpacer size="l"/>
                            <EuiCodeBlock language="jsx" fontSize="m"
                                          paddingSize="m">
                                { installCommand }
                            </EuiCodeBlock>
                            <EuiSpacer size="l"/>

                            <EuiCopy
                                textToCopy={ installCommand }>
                                { copy => (
                                    <EuiButton onClick={ copy }
                                               iconType={ 'copyClipboard' }
                                               color={ 'success' }>Click
                                        to
                                        copy</EuiButton>
                                ) }
                            </EuiCopy>

                        </RunCodeStyled>
                    </div>
                </EuiModalBody>
            </EuiModal>

        </ModalMainStyled>
    );
};

export default ModalUpdateAgent;
